export default __webpack_public_path__ + "static/media/1662.2df02f6e.png";